import { observable, computed, action, runInAction } from 'mobx';
import autobind from 'autobind-decorator';
import { asyncAction } from 'mobx-utils';
import HockeyModel from './model';
import AbstractScoreCommon from '../../store/common';
import { getDeletedGames, setDefaultList } from '../../shared/utils';
import WebSocketUtil from '../../../../common/utils/socketUtil';
import { ScoreService } from '../../../../common/services';

@autobind
class HockeyStore extends AbstractScoreCommon {
  socket = null;
  isSub = false;

  @observable
  list = [];

  @observable
  loading = false;

  constructor() {
    super();
  }

  connectSocket(topic) {
    this.socket = new WebSocketUtil(topic);

    this.socket.ws.onmessage = (event) => {
      if (event) {
        let data = event.data;

        try {
          if (data === 'OK') {
            this.isSub = true;
          } else {
            let messageData = JSON.parse(data);

            if (messageData) {
              const { TOPIC, MESSAGE } = messageData;

              if (TOPIC.includes('sports')) {
                const data = JSON.parse(MESSAGE);
                const copy = [...this.list.toJS()];
                let index = -1;

                if (data.hasOwnProperty('gameId')) {
                  index = copy.findIndex((item) => item.id === data.gameId);
                }

                if (Boolean(~index)) {
                  if (TOPIC === `sports.hockey.games`) {
                    this.list[index].updateGame(data.game);
                  }

                  if (TOPIC === `sports.hockey.period-data`) {
                    this.list[index].updatePeriodData(data.periodData);
                  }
                }

                if (TOPIC === `sports.hockey.cheers`) {
                  index = copy.findIndex((item) => item.id == data.game_id);
                  if (Boolean(~index)) {
                    this.list[index].cheerCount++;
                  }
                }
              }
            }
          }
        } catch (error) {
          console.log('=== socket on message error ===', error);
        }
      }
    };
  }

  /**********************************************************
   * computed
   **********************************************************/
  @computed
  get hockeyList() {
    const { list, selectedGames } = this;
    const deleteSelectedGames = getDeletedGames(list, selectedGames);

    return setDefaultList(deleteSelectedGames);
  }

  @computed
  get isFavoriteActiveCheck() {
    const { selectedList } = this;

    return selectedList.length > 0;
  }

  /**********************************************************
   * actions
   **********************************************************/
  @action
  closeSocket() {
    this.socket.close(() => {
      runInAction(() => {
        this.isSub = false;
        this.socket = null;
      });
    });
  }

  /**********************************************************
   * async actions
   **********************************************************/
  @asyncAction
  *getHockey(date) {
    this.loading = true;

    try {
      // TODO: 웹소켓;
      if (!this.isSub) {
        yield this.connectSocket([
          'sports.hockey.games',
          'sports.hockey.period-data',
          'sports.hockey.last-broadcast',
          'sports.hockey.special',
          'sports.hockey.cheers'
        ]);
      }

      const result = yield ScoreService.getSportsTypeGames(
        date,
        'ALL',
        'hockey'
      );

      if (result) {
        this.list = result.map((item) => new HockeyModel(item));

        this.loading = false;
      }

      // console.log('result success = ', result);
      // console.log(type, ' response = ', this.sports[type]);
    } catch (error) {
      console.log(error);
    }
  }
}

export default HockeyStore;
